import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { ToastrService } from "ngx-toastr";
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { BcLineModel } from "../models/societe-linked/bc/bc-line.model";
import { CycleBcService } from "./bc/cycle-bc.service";
import { FournisseurService } from "./societe-linked/fournisseur.service";
import { SocieteService } from "./simple/societe.service";
import { SiteService } from "./societe-linked/site.service";
import { CycleBcModel } from "../models/societe-linked/bc/cycle-bc.model";
import { FournisseurModel } from "../models/societe-linked/fournisseur.model";
import { SocieteModel } from "../models/simple-types/societe.model";
import { SiteModel } from "../models/societe-linked/site.model";
import { BcModel } from "../models/societe-linked/bc/bc.model";
import { map, switchMap, tap } from "rxjs/operators";
import { Observable, Subject, forkJoin, of } from "rxjs";
import { BcService } from "./bc/bc.service";
import { DefinitionTypeBC } from "../typeBCDefinitions";
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Injectable({ providedIn: 'root' })
export class PdfService {
    site: SiteModel;
    siteLivre: SiteModel;
    societe: SocieteModel;
    fourn: FournisseurModel;
    cycles: CycleBcModel[];
    enabled = false;
    emetteur: string;
    valideurAuto: string;
    valideur1: string;
    valideur2: string;
    valideur3: string;
    valideur4: string;
    valideur5: string;
  constructor(
    private siteService: SiteService,
    private societeService: SocieteService,
    private fournService: FournisseurService,
    private cycleBcService: CycleBcService,
    private bcService: BcService,
    private toastrService: ToastrService,
    private datepipe: DatePipe,
    public dialog: MatDialog
  ) {}

  getSiret(): string {
    return (this.site.siret1 ?
      (this.site.siret2 ? 'SIRET ' + this.site.siret1 + ' ' + this.site.siret2 : 'SIRET ' + this.site.siret1) : '') +
      this.site.naf ? ' - NAF ' + this.site.naf : '';
  }
  // TODO add adresse siteLivre si diff de Site
  getAdressesiteLivre(siteLivre: SiteModel): any {
    if (!siteLivre || siteLivre.code === this.site.code) {
      return {
        res: undefined,
        res2: undefined,
        res3: undefined
      };
    } else {
      return {
        res: [{ text: siteLivre.adr1 }, { text: ' ' }],
        res2: [{ text: siteLivre.adr2 }, { text: ' ' }],
        res3: [{ text: siteLivre.adr3 }, { text: ' ' }]
      };
    }
  }
    
  /**
   * Formate un objet de type Date en string avec le format dd/MM/yyyy et l'heure HH:mm si souhaité
   * @param date La date à formater
   * @param h Si la date doit aussi montrer l'heure
   * @returns une chaine de caractères qui contient la date formatée.
   */
  private formatDate(date: Date, h?: boolean): string {
    return h ? this.datepipe.transform(date, 'dd/MM/yyyy HH:mm') 
      : this.datepipe.transform(date, 'dd/MM/yyyy');
  }

  // delete generatepdf from this 
  // load infos to create the pdf
  loadInfos(bc: BcModel): Observable<any> {
    if (bc && bc.idSociete && bc.codeSite && bc.codeSiteLivraison && bc.codeFourn) {
      const join = [];
      return this.societeService.get(bc.idSociete).pipe(switchMap((societe) => {
          this.societe = societe;
          if (bc.codeSite === bc.codeSiteLivraison) {
            join.push(this.siteService.getFromCodeAndSociete(bc.codeSite, societe.id).pipe(tap((site: SiteModel) => {
              this.site = site;
              this.siteLivre = site;
            })));
          } else {
            join.push(this.siteService.getFromCodeAndSociete(bc.codeSite, societe.id).pipe(tap((site: SiteModel) => {
              this.site = site;
            })));
            join.push(this.siteService.getFromCodeAndSociete(bc.codeSiteLivraison, societe.id).pipe(tap((siteLivr: SiteModel) => {
              this.siteLivre = siteLivr;
            })));
          }
          join.push(this.fournService.getFromCodeAndSociete(bc.codeFourn, societe.id).pipe(tap((fourn: FournisseurModel) => {
            this.fourn = fourn;
          })));
          join.push(this.cycleBcService.getLastValideurs(bc.id).pipe(tap((cycles: CycleBcModel[]) => {
            this.cycles = cycles;
          })));
          return forkJoin(join).pipe(map((result) =>{
            this.enabled = true;
            return result;
          }));
      }));
            
    }else{
        return of(null);
    }
  }

  // load infos, create pdf and open it 
  print(bc: BcModel): void {
    this.loadInfos(bc).subscribe(infos => {
      // generate pdf
      let doc;
      if(bc.type === DefinitionTypeBC.BCEnveloppe){
        doc = this.generatePdfEnveloppe(bc, "print");
      }else{
        doc = this.generatePdf(bc, "print");
      }
      pdfMake.createPdf(doc).open();
    });
  }

  // load infos, create pdf and return it as Blob
  getBlob(bc: BcModel): Observable<Blob> {
    return this.loadInfos(bc).pipe(switchMap((infos) =>{
      // generate pdf
      let doc = this.generatePdf(bc, "send");
      const pdfDocGenerator = pdfMake.createPdf(doc);
      let blobSubject = new Subject<Blob>();
      pdfDocGenerator.getBlob((blob) => { 
        blobSubject.next(blob);
       });
       return blobSubject;
    }));
  }

  // TODO : ****************** ADAPTER AU BC ENVELOPPE ****************************
  // load infos, create pdf and return it as Blob
  getBlobEnveloppe(bc: BcModel): Observable<Blob> {
    return this.loadInfos(bc).pipe(switchMap((infos) =>{
      // generate pdf
      let doc = this.generatePdfEnveloppe(bc, "send");
      const pdfDocGenerator = pdfMake.createPdf(doc);
      let blobSubject = new Subject<Blob>();
      pdfDocGenerator.getBlob((blob) => { 
        blobSubject.next(blob);
       });
       return blobSubject;
    }));
  }

    // funtion that create the pdf 
  generatePdfEnveloppe(bc: BcModel, action: string): any {
    if (bc.statusNum >= 2) {

      const cbc = this.cycles.find(x => x ? x.statutOld === 'Brouillon' : null);
      this.emetteur = cbc ? `${cbc.user.nom} ${cbc.user.prenom} \n${cbc.user.email}` : '';
      if (bc.statusNum >= 6) {


        const valauto = this.cycles.find(x => x ? x.statutOld === 'Brouillon' && x.statutNew == 'Validé' : null);
        this.valideurAuto = valauto ? 'Valideur auto' : '';

        const val1 = this.cycles.find(x => x ? x.statutOld === 'A Valider' : null);
        this.valideur1 = val1 ? `${val1.user.nom}  ${val1.user.prenom} le ${this.formatDate(val1.dAction, true)}` : '';

        const val2 = this.cycles.find(x => x ? x.statutOld === 'Validation 1' : null);
        this.valideur2 = val2 ? `${val2.user.nom}  ${val2.user.prenom} le ${this.formatDate(val2.dAction, true)}` : '';

        const val3 = this.cycles.find(x => x ? x.statutOld === 'Validation 2' : null);
        this.valideur3 = val3 ? `${val3.user.nom}  ${val3.user.prenom} le ${this.formatDate(val3.dAction, true)}` : '';

        const val4 = this.cycles.find(x => x ? x.statutOld === 'Validation 3' : null);
        this.valideur4 = val4 ? `${val4.user.nom}  ${val4.user.prenom} le ${this.formatDate(val4.dAction, true)}` : '';

        const val5 = this.cycles.find(x => x ? x.statutOld === 'Validation 4' : null);
        this.valideur5 = val5 ? `${val5.user.nom}  ${val5.user.prenom} le ${this.formatDate(val5.dAction, true)}` : '';
      }
    }
    if (bc && this.site && this.fourn && this.societe) {
      const cycleDuplicata = this.cycles.find(x => x ? x.type === 'Envoi mail' : null);
      const doc = {
        info: {
          title: (bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx")
        },
        pageSize: 'A4',
        pageOrientation: 'Portrait', // 'landscape',
        pageMargins: [20, 220, 20, 155],
        watermark: {
          text: (((this.valideur1 + this.valideur2 + this.valideur3 + this.valideur4 + this.valideur5 + this.valideurAuto)) ? ((cycleDuplicata && action == "send") ? 'DUPLICATA' : '') : ('BROUILLON')),
          opacity: 0.3,
          bold: true,
          italics: false
        },
        header: {
          margin: 20,
          style: 'tableExample',
          columns: [
            {
              table: {
                widths: ['50%', '50%'],

                body: [
                  [{
                    text: [
                      { text: this.societe.libelle + '\n', style: 'subheader1', bold: true },
                      { text: 'Adresse de facturation : \n', style: 'subheader1', bold: true, decoration: 'underline' },
                      { text: this.site.adrFact1 ? this.site.adrFact1 + '\n' : '' },
                      { text: (this.site.adrFact2 && this.site.adrFact2.trim() !== '') ? this.site.adrFact2 + '\n' : '' },
                      { text: this.site.adrFact3 ? this.site.adrFact3 + '\n' : '' },
                      { text: this.site.email ? (this.site.email + '\n') : '', decoration: 'underline' },
                    ], fontSize: 10
                  },
                  {
                    text: [
                      { text: bc.libelleFourn, style: 'subheader1', bold: true }, '\n',
                      { text: this.fourn.adr1 ? this.fourn.adr1 + '\n' : '' },
                      { text: this.fourn.adr2 ? this.fourn.adr2 + '\n' : '' },
                      { text: this.fourn.cp + ' ' + this.fourn.ville }, '\n',
                      { text: this.fourn.pays }, '\n',
                      { text: this.fourn.tel ? ('Tel : ' + this.fourn.tel + '\n\n\n\n') : '\n\n\n\n' }
                    ]
                  }],  
                  [
                    {
                      table: {
                        widths: ['*', '*' ],
                        body: [
                          [{
                            text: [ //(Prestations facturées pour une période déterminée)\n
                              { text: 'COMMANDE ENVELOPPE\n' , style: 'header', bold: true, decoration: 'underline', alignment: 'center'},
                              { text: 'N° ' + bc.code , style: 'header', bold: true, alignment: 'center'},

                            ],                       
                            colSpan: 2
                            
                          }],
                        ]
                      },
                      colSpan: 2
                    }

                  ]
                ]
              },
              layout: 'noBorders'
            }

          ]
        },
        content: [
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {text: '\n\n\n', alignment: 'right'}    
                ]
              ]
            },
            layout: 'noBorders',
          },
          {
            table: {
              widths: ['*'],
              body: [
                [{ text: 'DESCRIPTION', bold: true, alignment: 'center', fontSize: 14 }],
                [
                  {
                    text: [
                      { text: this.breakLongWords(bc.libelle, 40) + '\n', alignment: 'center', fontSize: 14, bold: true  },
                      { text: "Identifiant d'adressage (e-facturation) : " + this.societe.siren + "\nMention : « Important : veuillez utiliser cet identifiant SIREN pour l'envoi de votre facture électronique »\n" + this.breakLongWords(bc.commentaires, 80), alignment: 'center', fontSize: 8 }
                    ],
                    colSpan: 1 // Ou la valeur appropriée pour votre cas d'utilisation
                  }
                ]
              ]
            },
          },
          {
            table: {
              widths: ['*'],
              body: [
                [
                  {text: '\n\n\n', alignment: 'right'}    
                ]
              ]
            },
            layout: 'noBorders',
          },
          {
            table: {
              widths: ['*'],
              body: [
                [{ text: 'DATE DE FIN DE VALIDITE', bold: true, alignment: 'center', fontSize: 14 }],
                [{ text: this.formatDate(bc.dFinValid), alignment: 'center', fontSize: 14 }],
              ]
            },
          },
          {
            table: {
              widths: ['*'],
              body: [
                [{ text: '\n\n\n\n\nSpécifier sur la facture :', bold: true, decoration: 'underline' }],
                [{ text: '    - La mention "Facture" ou "Avoir."' }],
                [{ text: '    - Le numéro de commande.' }],
                [{ text: '    - Le numéro de SIRET.' }],
                [{ text: '    - La date de facture.' }]
              ]
            },
            layout: 'noBorders',
          }
        ],
        footer: (currentPage, pageCount) => {
          let signatures = { text: '' };
          return [signatures, {
            style: 'tableFooter',
            layout: 'noBorders',
            margin: [20, 0, 20, 0],
            table: {
              widths: ['*', '*', '*'],
              body: [
                [this.formatDate(new Date(Date.now()), true), // Date du jour formatée avec heure et minute
                { text: ' ' },
                { text: 'page ' + currentPage.toString() + ' / ' + pageCount, alignment: 'right' }],
                [{ text: 'Conditions Générales d\'achat Assainissement et Maintenance France', link: 'https://assainissement-et-maintenance.veolia.fr/conditions-generales-achat' }, { text: '' }, { text: '' }],
                ['', { text: this.societe.capitalSocial, alignment: 'center' }, ''],
                ['', { text: this.societe.siren + ' ' + this.societe.rsc + ' - ' + this.societe.tvaIntraComm, alignment: 'center' }, '']
              ]
            }
          }];
        },
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            // margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            // margin: [0, 10, 0, 5]
          },
          tableExample: {
            // margin: [0, 5, 0, 15]
          },
          tableFooter: {
            fontSize: 10,
            margin: [10, 0, 10, 10]
          },
          tableOpacityExample: {
            // margin: [0, 5, 0, 15],
            fillColor: 'blue',
            fillOpacity: 0.3
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      };
      return doc;
    } else {
      this.toastrService.warning('Veuillez mémoriser les sites ainsi que le fournisseur pour générer une facture');
      return null;
    }
  }
  // funtion that create the pdf 
  generatePdf(bc: BcModel, action: string): any {
    if (bc.statusNum >= 2) {

      const cbc = this.cycles.find(x => x ? x.statutOld === 'Brouillon' : null);
      this.emetteur = cbc ? `${cbc.user.nom} ${cbc.user.prenom} \n${cbc.user.email}` : '';
      if (bc.statusNum >= 6) {

        const valauto = this.cycles.find(x => x ? x.statutOld === 'Brouillon' && x.statutNew == 'Validé' : null);
        this.valideurAuto = valauto ? 'Valideur auto' : '';

        const val1 = this.cycles.find(x => x ? x.statutOld === 'A Valider' : null);
        this.valideur1 = val1 ? `${val1.user.nom}  ${val1.user.prenom} le ${this.formatDate(val1.dAction, true)}` : '';

        const val2 = this.cycles.find(x => x ? x.statutOld === 'Validation 1' : null);
        this.valideur2 = val2 ? `${val2.user.nom}  ${val2.user.prenom} le ${this.formatDate(val2.dAction, true)}` : '';

        const val3 = this.cycles.find(x => x ? x.statutOld === 'Validation 2' : null);
        this.valideur3 = val3 ? `${val3.user.nom}  ${val3.user.prenom} le ${this.formatDate(val3.dAction, true)}` : '';

        const val4 = this.cycles.find(x => x ? x.statutOld === 'Validation 3' : null);
        this.valideur4 = val4 ? `${val4.user.nom}  ${val4.user.prenom} le ${this.formatDate(val4.dAction, true)}` : '';

        const val5 = this.cycles.find(x => x ? x.statutOld === 'Validation 4' : null);
        this.valideur5 = val5 ? `${val5.user.nom}  ${val5.user.prenom} le ${this.formatDate(val5.dAction, true)}` : '';

      }
    }
    if (bc && this.site && this.fourn && this.societe) {
      const cycleDuplicata = this.cycles.find(x => x ? x.type === 'Envoi mail' : null);
      const bcLines = this.generateBcLines(bc.bcLines, bc.ht);
      const doc = {
        info: {
          title: (bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx")
        },
        pageSize: 'A4',
        pageOrientation: 'Portrait', // 'landscape',
        pageMargins: [20, 420, 20, 155],
        watermark: {
          text: ((this.valideur1 + this.valideur2 + this.valideur3 + this.valideur4 + this.valideur5 + this.valideurAuto) ? ((cycleDuplicata && action == "send") ? 'DUPLICATA' : '') : ('BROUILLON')),
          opacity: 0.3,
          bold: true,
          italics: false
        },
        footer: (currentPage, pageCount) => {
          let signatures;
          if (currentPage === pageCount) {
            signatures = [{
              table: {
                widths: ['*', '*'],

                body: [
                  [[{ text: 'Emetteur', bold: true }, { text: this.emetteur }],
                  [{ text: 'Valideurs', bold: true }, { text: this.valideur1 }
                    , { text: this.valideur2 }, { text: this.valideur3 }
                    , { text: this.valideur4 }, { text: this.valideur5 }]]]
              }, margin: [20, 0, 20, 0]
            }];
          }
          else {
            signatures = { text: '' };
          }

          return [signatures, {
            style: 'tableFooter',
            layout: 'noBorders',
            margin: [20, 0, 20, 0],
            table: {
              widths: ['*', '*', '*'],
              body: [
                [this.formatDate(new Date(Date.now()), true), // Date du jour formatée avec heure et minute
                { text: ' ' },
                { text: 'page ' + currentPage.toString() + ' / ' + pageCount, alignment: 'right' }],
                [{ text: 'Conditions Générales d\'achat Assainissement et Maintenance France', link: 'https://assainissement-et-maintenance.veolia.fr/conditions-generales-achat' }, { text: '' }, { text: '' }],
                ['', { text: this.societe.capitalSocial, alignment: 'center' }, ''],
                ['', { text: this.societe.siren + ' ' + this.societe.rsc + ' - ' + this.societe.tvaIntraComm, alignment: 'center' }, '']]
            }
          }];
        },


        header: {
          margin: 20,
          style: 'tableExample',
          columns: [
            {
              table: {
                widths: ['50%', '50%'],

                body: [
                  // tslint:disable-next-line: max-line-length
                  [{ text: ' ' }, { text: 'Le ' + this.formatDate(bc.dBc, false), alignment: 'right' }],
                  [{ text: this.societe.libelle, style: 'subheader1', bold: true }, { text: ' ' }],
                  [{
                    text: [
                      { text: (this.siteLivre && this.siteLivre.code === this.site.code) ? 'Adresse de livraison: \n' : 
                      '', bold: true, decoration: 'underline' },
                      { text: this.site.libelle }, '\n',
                      { text: this.site.adr1 ? this.site.adr1 + '\n' : '' },
                      { text: (this.site.adr2 && this.site.adr2.trim() !== '') ? this.site.adr2 + '\n' : '' },
                      { text: this.site.adr3 ? this.site.adr3 + '\n' : '' },
                      { text: this.site.tel ? 'Tel : ' + this.site.tel + '\n' : '' }, '\n',

                      { text: 'Adresse de facturation : \n', bold: true, decoration: 'underline' },
                      { text: this.site.adrFact1 ? this.site.adrFact1 + '\n' : '' },
                      { text: (this.site.adrFact2 && this.site.adrFact2.trim() !== '') ? this.site.adrFact2 + '\n' : '' },
                      { text: this.site.adrFact3 ? this.site.adrFact3 + '\n' : '' },
                      { text: this.site.email ? 'Email : ' + this.site.email + '\n' : '' }, '\n',
                      {
                        text: (this.siteLivre && (this.siteLivre.code !== this.site.code)
                          ) ? 'Adresse de livraison :\n' : '', bold: true, decoration: 'underline'
                      },
                      { text: (this.siteLivre && this.siteLivre.adr1 && this.siteLivre.code !== this.site.code) ? this.siteLivre.adr1 + '\n' : '' },
                      { text: (this.siteLivre && this.siteLivre.adr2 && this.siteLivre.code !== this.site.code && this.siteLivre.adr2.trim() !== '') ? this.siteLivre.adr2 + '\n' : '' },
                      { text: (this.siteLivre && this.siteLivre.adr3 && this.siteLivre.code !== this.site.code) ? this.siteLivre.adr3 + '\n' : '' },
                      { text: (this.siteLivre && this.siteLivre.tel && this.siteLivre.tel !== this.site.tel) ? 'Tel : ' + this.siteLivre.tel + '\n' : '' }, '\n',
                    ], fontSize: 10
                  },
                  {
                    text: [
                      '\n\n\n',
                      { text: bc.libelleFourn, style: 'subheader1', bold: true }, '\n',
                      { text: this.fourn.adr1 ? this.fourn.adr1 + '\n' : '' },
                      { text: this.fourn.adr2 ? this.fourn.adr2 + '\n' : '' },
                      { text: this.fourn.cp + ' ' + this.fourn.ville }, '\n',
                      { text: this.fourn.pays }, '\n',
                      { text: this.fourn.tel ? 'Tel : ' + this.fourn.tel + '\n' : '' }
                    ]
                  }],
                  [{ text: 'Rappel: Toute facture sans n° de BDC sera retournée', fontSize: 23, colSpan: 2 }],
                  [{
                    text: [{ text: (bc.ht < 0 ? 'DEMANDE D\'AVOIR' : 'BON DE COMMANDE ') + (bc.fValide === 2 ? bc.code : "Cxxxxxxxxxx"), style: 'header', bold: true },
                      '   ', // Emplacement du Duplicata ou Brouillon
                    { text: bc.mention, fontSize: 8 }
                    ], colSpan: 2
                  }],
                  [
                    {
                      table: {
                        widths: [100, '*'],
                        body: [
                          [{ border: [true, true, false, false], text: 'Vos références' },
                          { border: [false, true, true, false], text: bc.refFourn }],
                          [{ border: [true, false, false, false], text: 'Nos références' },
                          { border: [false, false, true, false], text: this.fourn.code + ' ' + this.fourn.libelle }],
                          [{ border: [true, false, false, false], text: 'Règlement' },
                          { border: [false, false, true, false], text: bc.libelleModeRegl + '     ' + bc.libelleCondRegl }],
                          [{ border: [true, false, false, true], text: 'Observation', fontSize: 10 },
                          { border: [false, false, true, true], text: "Identifiant d'adressage (e-facturation) : " + this.societe.siren + "\nMention : « Important : veuillez utiliser cet identifiant SIREN pour l'envoi de votre facture électronique »\n" + this.breakLongWords(bc.commentaires, 60), fontSize: 10 }]
                        ]
                      },
                      colSpan: 2
                    },
                  ]
                ]
              },
              layout: 'noBorders'
            }

          ]
        },
        content: [
          {
            padding: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
            style: 'tableExample',
            table: {
              widths: [25, '*', 46, 65, 65],
              padding: [0, 0, 0, 0],
              margin: [0, 0, 0, 0],
              body:
                bcLines
            },
            layout: { defaultBorder: false, }
          },
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            // margin: [0, 0, 0, 10]
          },
          subheader: {
            fontSize: 16,
            bold: true,
            // margin: [0, 10, 0, 5]
          },
          tableExample: {
            // margin: [0, 5, 0, 15]
          },
          tableFooter: {
            fontSize: 10,
            margin: [10, 0, 10, 10]
          },
          tableOpacityExample: {
            // margin: [0, 5, 0, 15],
            fillColor: 'blue',
            fillOpacity: 0.3
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: 'black'
          }
        },
        defaultStyle: {
          // alignment: 'justify'
        }
      };
      return doc;
    } else {
      this.toastrService.warning('Veuillez mémoriser les sites ainsi que le fournisseur pour générer une facture');
      return null;
    }
  }
  
  breakLongWords(str, maxLength) {
    let brokenString = '';
    let currentWord = '';
    let lineLength = 0;
  
    if (!str || str.trim().length === 0) {
      return '';
    }
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '\n') {
        // If we encounter a line break, add the current word and reset
        brokenString += currentWord + '\n';
        currentWord = '';
        lineLength = 0;
      } else {
        currentWord += str[i];
        lineLength++;
  
        if (lineLength >= maxLength) {
          brokenString += currentWord + '-\n';// Add a hyphen and line break
          currentWord = '';
          lineLength = 0;
        }
      }
    }
    brokenString += currentWord; // Add the remaining part of the string
    return brokenString;
  }  

  /**
   * Génère la partie BcLines du PDF à partir des BcLines trouvées dans le BC
   * @param lines Les lignes du BC
   * @returns un tableau utilisable dans le générateur de PDF
   */
  private generateBcLines(lines: BcLineModel[], total: number): any[] {
    const arr = [];
    arr.push([
      {
        text: ' '
      },
      {
        bold: true,
        text: 'Désignation'
      },
      {
        alignment: 'right',
        bold: true,
        text: 'Quantité'
      },
      {
        alignment: 'right',
        bold: true,
        text: 'PU'
      },
      {
        alignment: 'right',
        bold: true,
        text: 'Montant'
      }
    ]
    );
    for (const line of lines) {
      arr.push([// bcLines[x] n°1/2
        {
          alignment: 'right',
          fontSize: 10,
          text: line.code
        },
        {
          text: this.breakLongWords(line.libelle, 40),
          fontSize: 11,
        },
        {
          alignment: 'right',
          // text: format(line.qte) ne fonctionne pas
          // text: line.qte.toFixed(3) affiche bien les 3 décimales mais le séparateur de millier et de décimal est faux
          text: line.qte.toFixed(3),
          fontSize: 11
        },
        {
          alignment: 'right',
          text: line.pu.toFixed(2) + '€',
          fontSize: 11,
        },
        {
          alignment: 'right',
          text: line.ht.toFixed(2) + '€',
          fontSize: 11,
        }
      ],
      );
      arr.push([// bcLines[x] n°2/2
        {
          border: [false, false, false, true],
          alignment: 'right',
          fontSize: 10,
          text: ' '
        },
        {
          border: [false, false, false, true],
          fontSize: 8,
          text: 'CG ' + line.codeCgCharge + '     NA ' + line.codeNa + '     CA1 ' + line.codeCa1 + '     Chantier ' + line.chantier + '     Livraison le ' + this.formatDate(line.dLivraison, false)
        },
        {
          border: [false, false, false, true],
          text: ' '
        },
        {
          border: [false, false, false, true],
          text: ' '
        },
        {
          border: [false, false, false, true],
          text: ' '
        }
      ]);
    }
    arr.push([ // Ligne HT
      {
        border: [false, false, false, true],
        text: ' '
      },
      {
        border: [false, false, false, true],
        text: ' '
      }, {
        border: [false, false, false, true],
        alignment: 'right',
        text: 'Total HT '
      },
      {
        border: [false, false, false, true],
        alignment: 'right',
        text: total.toFixed(2) + '€',
        colSpan: 2
      },
    ]
    );
    return arr;
  }

}